<template>
  <!-- Modal -->
  <div>
    <div class="modal" id="subscriptionDetails">
      <div
        class="modal-dialog modal-xl modal-payments-info-dialog"
        role="document"
      >
        <div class="modal-content modal-subscription">
          <div class="modal-header">
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <i class="fa fa-times" aria-hidden="true"></i>
            </button>
          </div>
          <div class="modal-body">
            <div class="container-fluid">
              <div class="row">
                <div class="col-12 text-center">
                  <h2 class="plan-header">Porque cada empresa es única</h2>
                </div>
              </div>
              <div class="row mt-2">
                <div class="col-12 text-center">
                  <h1 class="plan-subheader">
                    Elije el plan que más se ajuste a tus necesidades
                  </h1>
                </div>
              </div>
              <div class="row my-3">
                <div class="col-12">
                  <div
                    class="d-flex justify-content-center align-items-center mb-3"
                  >
                    <span class="mr-2 plan-header" style="font-size: 18px"
                      >Pago mensual</span
                    >
                    <label class="switch m-0">
                      <input type="checkbox" v-model="switchPeriod" />
                      <span class="slider round"></span>
                    </label>
                    <span class="ml-2 plan-header" style="font-size: 18px"
                      >Pago anual</span
                    >
                    <div
                      class="ml-3 percentage-promo"
                      v-show="switchPeriod != false"
                    >
                      20% OFF
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-12">
                  <div class="d-flex flex-row align-items-start w-100">
                    <div
                      class="subscription-item col-4"
                      v-for="(subscription, index) in availableSubscriptions"
                      :key="index"
                    >
                      <div class="category">
                        {{ subscription.name }}
                      </div>
                      <div
                        class="w-100"
                        v-for="(price, sub) in plansMonth(subscription.prices)"
                        :key="sub.name"
                      >
                        <div
                          class="price mb-3"
                          v-bind:class="{
                            active: isPlanActive(subscription.name),
                          }"
                          v-show="switchPeriod == false"
                          v-if="price.recurring == 'month'"
                        >
                          <div class="d-flex flex-column">
                            <div>
                              <span v-if="subscription.name != 'Básico'"
                                >{{ price.price | currency }}
                              </span>
                              <span v-else>{{ price.price }}</span>
                              <sup v-if="subscription.name != 'Básico'">{{
                                price.currency
                              }}</sup>
                            </div>
                            <div
                              v-if="subscription.name != 'Básico'"
                              style="font-size:10px;"
                            >
                              ¡PRUÉBALO 30 DÍAS GRATIS!
                            </div>
                          </div>
                        </div>
                      </div>

                      <div
                        class="w-100"
                        v-for="(price, yearsub) in plansYear(
                          subscription.prices
                        )"
                        :key="yearsub.name"
                      >
                        <div
                          class="price mb-3"
                          v-bind:class="{
                            active: isPlanActive(subscription.name),
                          }"
                          v-show="switchPeriod != false"
                          v-if="price.recurring == 'year'"
                        >
                          <div class="d-flex flex-column">
                            <div>
                              <span v-if="subscription.name != 'Básico'"
                                >{{ price.price | currency }}
                              </span>
                              <span v-else>{{ price.price }}</span>
                              <sup v-if="subscription.name != 'Básico'">{{
                                price.currency
                              }}</sup>
                            </div>
                            <div
                              v-if="subscription.name != 'Básico'"
                              style="font-size:10px;"
                            >
                              ¡PRUÉBALO 30 DÍAS GRATIS!
                            </div>
                          </div>
                        </div>
                      </div>

                      <div class="row m-0 p-0 w-100">
                        <div class="col-12 text-center">
                          <button
                            v-if="isPlanActive(subscription.name)"
                            type="button"
                            class="btn btn-save"
                          >
                            Plan activo
                          </button>
                          <button
                            type="button"
                            class="btn btn-outlined"
                            v-else
                            @click="showModalAfiliate(subscription)"
                          >
                            Activar {{ subscription.name }}
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row mt-4">
                <div class="col-12 text-center">
                  Precios incluyen IVA
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <div class="container fluid">
              <div class="row w-100 mt-4">
                <div class="col-12">
                  <div
                    class="d-flex w-100 align-items-center justify-content-center"
                  >
                    <a
                      class="btn btn-simple mr-4"
                      href="https://www.cotizarlo.com/planes-y-precios/ "
                      target="_blank"
                      >Ver descripciones de planes</a
                    >
                    <button
                      type="button"
                      class="btn btn-outlined"
                      @click="showCancelModal()"
                    >
                      Cancelar mi plan
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <subscription-afiliate
      :selectedPlan="selectedPlan"
      :countries="countriesList"
      v-if="selectedPlan != null && planDetails.plan_type == 1"
    />
    <subscription-change-plan
      v-if="selectedPlan != null && planDetails.plan_type != 1"
      :selectedPlan="selectedPlan"
    />
  </div>
</template>

<script>
import data from "@/mixins/data";
import filters from "@/mixins/filters";
import $ from "jquery";
import SubscriptionAfiliate from "@/components/settings/payments_config/SubscriptionAfiliate";
import SubscriptionChangePlan from "@/components/settings/payments_config/SubscriptionChangePlan";
import plansService from "@/api/plans";
import clientService from "@/api/clients";
export default {
  mixins: [data, filters],
  components: {
    SubscriptionAfiliate,
    SubscriptionChangePlan,
  },
  beforeMount() {
    this.getCountries().then((response) => {
      this.countriesList = response;
    });
  },

  beforeDestroy() {
    $(".modal-backdrop").remove();
  },

  props: {
    subscriptions: {
      required: true,
    },
  },

  data() {
    return {
      switchPeriod: false,
      selectedPlan: null,
      countriesList: [],
    };
  },

  computed: {
    availableSubscriptions() {
      return this.subscriptions.filter(
        (subscription) => subscription.prices.length > 0
      );
    },

    userSubscription() {
      var plan = "Básico";
      switch (this.planDetails.plan_type) {
        case 1:
          plan = "Básico";
          break;

        case 2:
          plan = "Personal";
          break;

        case 3:
          plan = "Equipo";
          break;
      }
      return plan;
    },
  },

  methods: {
    plansYear(subs) {
      return subs.filter((sub) => sub.recurring === "year");
    },
    plansMonth(subs) {
      return subs.filter((sub) => sub.recurring === "month");
    },
    getCountries() {
      return new Promise((resolve, reject) => {
        clientService
          .getCountriesList()
          .then((response) => {
            resolve(response.data.data);
          })
          .catch((e) => reject(e));
      });
    },
    showCancelModal() {
      $("#subscriptionDetails")
        .modal()
        .hide();
      $(".modal-backdrop").remove();
      $("#cancelSubscription")
        .modal()
        .show();
    },
    currentSelectedPlanFormat() {
      let select;
      switch (this.selectedPlan.period) {
        /* Mensual */
        case 1:
          /* Plan Personal */
          if (this.selectedPlan.plan == 2) {
            select = "individual_month";
          }

          if (this.selectedPlan.plan == 3) {
            select = "team_month";
          }
          break;

        /* Anual */
        case 2:
          if (this.selectedPlan.plan == 2) {
            select = "individual_year";
          }

          if (this.selectedPlan.plan == 3) {
            select = "team_year";
          }
          break;
      }
      return select;
    },
    isPlanActive(name) {
      if (!this.switchPeriod) {
        if (this.planDetails.plan_frecuency == 1) {
          return name == this.userSubscription ? true : false;
        } else {
          if (name == "Básico") {
            return name == this.userSubscription ? true : false;
          }
        }
      } else {
        if (this.planDetails.plan_frecuency == 2) {
          return name == this.userSubscription ? true : false;
        } else {
          if (name == "Básico") {
            return name == this.userSubscription ? true : false;
          }
        }
      }
    },
    showModalAfiliate(subscription) {
      this.selectedPlan = null;
      var planType = null;
      if (subscription.name == "Basico") {
        planType = 1;
      }
      if (subscription.name == "Personal") {
        planType = 2;
      }
      if (subscription.name == "Equipo") {
        planType = 3;
      }
      this.selectedPlan = {
        period: this.switchPeriod == false ? 1 : 2,
        plan: planType,
        subscription: subscription,
      };

      if (this.planDetails.plan_type == 1) {
        setTimeout(() => {
          $("#subscriptionDetails").modal("hide");
          $(".modal-backdrop").remove();
          $("#subscriptionAfiliate").modal("show");
        }, 500);
      } else {
        let planType = this.currentSelectedPlanFormat();
        if (planType != undefined) {
          setTimeout(() => {
            $("#subscriptionDetails").modal("hide");
            $(".modal-backdrop").remove();
            $("#changePlan").modal("show");
          }, 500);
        } else {
          this.$store.dispatch("showLoader", { show: true });
          plansService.cancelSubscription().then(() => {
            this.$store.dispatch("client/setData").then(() => {
              $(".modal-backdrop").remove();
              $("#subscriptionDetails").modal("hide");
              this.$store.dispatch("showLoader", { show: false });
            });
          });
        }
      }
    },
  },
  created() {},
};
</script>
